import * as types from "../types";

const initialState = {
  patterns: [],
  wallpapers: [],
};

const wallpapersReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.BG_WALLPAPERS_SUCCESS:
      return {
        ...state,
        patterns: action.payload.data.patterns.objects,
        wallpapers: action.payload.data.wallpapers.objects,
      };

    case types.BG_WALLPAPERS_FAILURE:
      return {
        ...state,
        patterns: ["12"],
        wallpapers: ["21"],
      };
    default:
      return state;
  }
};

export default wallpapersReducer;
